import React, { FC } from 'react'
import Layout from '../components/layout/Layout'
import ErrorHandlingInterceptor from '../components/error-handling/ErrorHandlingInterceptor'
import { MsalAuthenticationTemplate } from '@azure/msal-react'
import { AuthError, InteractionType } from '@azure/msal-browser'
import { requestScopes } from '../services/AuthConfig'
import OrgsOverview from '../components/orgs-overview/OrgsOverview'
import { AUTH_PROVIDER } from '../App'

const Portal: FC = () => {
  const params = new URL(document.location.href).searchParams
  const app = params.get('app')

  return AUTH_PROVIDER === 'msal' ? (
    <MsalAuthenticationTemplate
      interactionType={InteractionType.Redirect}
      authenticationRequest={{ scopes: requestScopes, state: app ?? '' }}
      errorComponent={ErrorComponent}
    >
      <ErrorHandlingInterceptor>
        <Layout>
          <OrgsOverview />
        </Layout>
      </ErrorHandlingInterceptor>
    </MsalAuthenticationTemplate>
  ) : (
    <ErrorHandlingInterceptor>
      <Layout>
        <OrgsOverview />
      </Layout>
    </ErrorHandlingInterceptor>
  )
}

const ErrorComponent: FC<{ error: AuthError | null }> = ({ error }) => {
  return <div>{error?.errorMessage}</div>
}

export default Portal
